/**
 * 管理方-数据统计
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const statisticRoutes: any = {
  path: 'statistic',
  name: '数据统计-管理',
  icon: 'ift-stat_2',
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'list'
    },
    {
      path: 'list',
      redirect: 'list',
      name: '数据统计',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-statisticList',
          meta: {
            text: '数据总览',
            type: 'main',
            role: ['6002']
          },
          component: () => import('../views/statistic/index.vue')
        },
        {
          path: 'stat-detail/:type?',
          name: 'desk-statisticDetail',
          meta: {
            text: '总览明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/detail.vue')
        }
      ]
    },
    {
      path: 'staff-stat',
      redirect: 'staff-stat',
      name: '数据统计',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-statisticStaffList',
          meta: {
            text: '员工数据',
            type: 'staff',
            role: ['6003']
          },
          component: () => import('../views/statistic/staff.vue')
        },
        // 员工明细-成员-创作方
        {
          path: 'stat-detail/:type/:userid',
          name: 'desk-statisticStaffDetail',
          meta: {
            text: '员工明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/detail-staff.vue')
        },
        // 员工明细-成员-创作管理方
        {
          path: 'stat-detail-staff-nor/:userid',
          name: 'desk-statisticStaffManagerDetail',
          meta: {
            text: '员工明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/detail-staff-manager.vue')
        },
        {
          path: 'links',
          name: 'desk-statisticStaffLinks',
          meta: {
            text: '环节明细',
            type: 'detail',
            role: ['6002', '6003']
          },
          component: () => import('../views/statistic/links.vue')
        }
      ]
    },
    {
      path: 'project-settle',
      redirect: 'project-settle',
      name: '数据统计',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-project-all',
          meta: {
            text: '项目结算',
            type: 'index',
            role: ['6011', '6012']
          },
          component: () => import('../views/statistic/project.vue')
        }
      ]
    },
    {
      path: 'comic-stat/:id',
      redirect: 'comic-stat/:id',
      name: '数据统计',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-statisticComicList',
          meta: {
            text: '项目总览',
            type: 'main',
            role: ['6002', '6003']
          },
          component: () => import('../views/statistic/comic.vue')
        },
        {
          path: 'stat-detail/:type/:id',
          name: 'desk-statisticComicDetail',
          meta: {
            text: '项目明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/detail-comic.vue')
        },
        {
          // 成员-创作方
          path: 'stat-detail-nor/:type/:id/:userid',
          name: 'desk-statisticComicNorDetail',
          meta: {
            text: '项目明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/detail-comic-nor.vue')
        },
        // 成员-管理方
        {
          path: 'stat-detail-comic/:id/:userid',
          name: 'desk-statisticDetailComicDetail',
          meta: {
            text: '项目明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/detail-comic-staff.vue')
        },
        {
          // 管理方（成员-创作管理方也是此页面）
          path: 'stat-overdue-detail/:id/:type/:userid?',
          name: 'desk-statisticOverdueComicDetail',
          meta: {
            text: '逾期明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/overdue-detail-comic.vue')
        },
        {
          // 成员-创作方
          path: 'stat-overdue-detail-staff/:id/:userid',
          name: 'desk-statisticOverdueComicStaffDetail',
          meta: {
            text: '逾期明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/overdue-detail-comic-staff.vue')
        },
        {
          path: 'stat-approve-detail/:id/:time?',
          name: 'desk-statisticApproveComicDetail',
          meta: {
            text: '审批明细',
            type: 'detail',
          },
          component: () => import('../views/statistic/approve-detail-comic.vue')
        }
      ]
    }
  ]
};

export {
  statisticRoutes
};
